// extracted by mini-css-extract-plugin
var _1 = "gNTSQ__friends";
export { _1 as "friends" }
